import { useCallback, useState } from "react";

import { LoopPositionSortType, UserLoopFilter } from "@bridgesplit/abf-sdk";
import { SortDirection } from "@bridgesplit/utils";
import { LoopPositionExpanded } from "@bridgesplit/abf-react";

import { useChunkedPaginationController } from "./shared";

const DEFAULT_PAGE_SIZE = 5;

export function useLoopsPagination() {
    const [activeOnly, setActiveOnly] = useState<boolean>(true);
    const [principalMint, setPrincipalMint] = useState<string>();
    const [collateralMint, setCollateralMint] = useState<string>();
    const [sortDirection, setSortDirection] = useState<SortDirection>(SortDirection.Desc);
    const [sortType, setSortType] = useState<LoopPositionSortType>(LoopPositionSortType.NetPositionValue);

    const chunkedPagination = useChunkedPaginationController<LoopPositionExpanded, UserLoopFilter>(
        {
            loopVaults: [],
            active: activeOnly,
            principalMint,
            collateralMint,
            sortDirection,
            sortType
        },
        DEFAULT_PAGE_SIZE
    );

    const reset = useCallback(() => {
        setActiveOnly(true);
        setPrincipalMint(undefined);
        setCollateralMint(undefined);
        chunkedPagination.resetPagination();
    }, [chunkedPagination, setActiveOnly, setPrincipalMint, setCollateralMint]);

    return {
        ...chunkedPagination, //Backend pagination params
        params: chunkedPagination.clientPagination, //Client pagination params
        setActiveOnly,
        setPrincipalMint,
        setCollateralMint,
        setSortDirection,
        setSortType,
        reset
    };
}
